import React, { useContext } from 'react';
import SectionHotelTitle from '../../../components/SectionTitle/SectionTitle';
import SectionTitle from '../../yourProperties/Title';

import { ContextUserProfile } from '../../../../contexts/UserProfileContext';
import Card from '../../../../muiComponents/Card';
import {
    AGE_SEGMENT_COLOR,
    avatarColumnGrid,
    gridColumnsSpacing,
    gridRowsSpacing,
    singleColumnGrid,
    imageColumnGrid,
} from '../../../../utils/bookings/bookingUtils';
import StarRating from './StarRating';
import Title from '../../../components/Title';
import Icon from '../../../../muiComponents/Icon';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import BookingRoomAvatar from './avatars/BookingRoomAvatar';
import Tag from '../../../../muiComponents/Tag';
import Image from '../../../components/Image';

const HotelInfo = props => {
    const { hotel, rating, hotelCategory, address, hotelImages, rooms } = props;
    const { translate } = useContext(ContextUserProfile);

    return (
        <section className='booking__section'>
            <SectionTitle text={translate('hotel')} />
            <Card className='booking__card padding20 flex-column gap-20'>
                <div className='flex flex-align-center flex-between padding15'>
                    <div className='flex-column gap-5'>
                        <SectionHotelTitle
                            title={hotel}
                            className='text-capitalize text-secunday-700'
                        />
                        <StarRating rating={rating} title={hotelCategory} />
                    </div>
                    <div className='flex-column flex-align-end gap-5'>
                        <div className='flex flex-align-center gap-5 text-overflow-ellipsis'>
                            <Icon
                                iconName='LocationOnOutlined'
                                className='text-secunday-700'
                            />

                            <Title className='text-capitalize'>
                                {translate('address')}
                            </Title>
                        </div>
                        <p className='text-align-end'>{address}</p>
                    </div>
                </div>
                <Grid
                    columnSpacing={gridColumnsSpacing}
                    rowSpacing={gridRowsSpacing}
                    style={{ width: 'unset' }}
                    className='padding15'
                >
                    {hotelImages.map((img, ind) => (
                        <GridChild
                            gridProps={imageColumnGrid}
                            key={img?.id || ind}
                        >
                            <Image
                                className='booking__image'
                                src={img?.virtualPath || ''}
                                useLocalBaseUrl={false}
                            />
                        </GridChild>
                    ))}
                </Grid>

                <div className='flex-column gap-5'>
                    {rooms?.map(room => {
                        return (
                            <div key={room.id} className='flex-column g'>
                                <SectionHotelTitle
                                    title={`${translate('room')}: ${
                                        room.roomType
                                    }`}
                                    className='text-capitalize text-secunday-700 padding15'
                                />
                                <Grid
                                    style={{ width: 'auto', margin: 0 }}
                                    columnSpacing={gridColumnsSpacing}
                                    rowSpacing={gridRowsSpacing}
                                >
                                    {room.roomMappingCode ? (
                                        <GridChild gridProps={singleColumnGrid}>
                                            <div className='flex-column gap-5'>
                                                <div className='flex flex-align-center gap-5 text-overflow-ellipsis'>
                                                    <Icon
                                                        iconName='Newspaper'
                                                        className='text-secunday-700'
                                                    />
                                                    <Title className='text-capitalize'>
                                                        {translate('room_code')}
                                                    </Title>
                                                </div>
                                                <p>{room.roomMappingCode}</p>
                                            </div>
                                        </GridChild>
                                    ) : (
                                        ''
                                    )}
                                    {room.mealPlan ||
                                    room.mealPlanMappingCode ? (
                                        <GridChild gridProps={singleColumnGrid}>
                                            <div className='flex-column gap-5'>
                                                <div className='flex flex-align-center gap-5 text-overflow-ellipsis'>
                                                    <Icon
                                                        iconName='RoomService'
                                                        className='text-secunday-700'
                                                    />
                                                    <Title className='text-capitalize'>
                                                        {translate('meal_plan')}
                                                    </Title>
                                                </div>
                                                <p>{`${room.mealPlan || ''} - ${
                                                    room.mealPlanMappingCode
                                                }`}</p>
                                            </div>
                                        </GridChild>
                                    ) : (
                                        ''
                                    )}

                                    {room.ratePlan ||
                                    room.ratePlanMappingCode ? (
                                        <GridChild gridProps={singleColumnGrid}>
                                            <div className='flex-column gap-5'>
                                                <div className='flex flex-align-center gap-5 text-overflow-ellipsis'>
                                                    <Icon
                                                        iconName='RequestQuote'
                                                        className='text-secunday-700'
                                                    />
                                                    <Title className='text-capitalize'>
                                                        {translate('rate_plan')}
                                                    </Title>
                                                </div>
                                                <p>{`${room.ratePlan || ''} - ${
                                                    room.ratePlanMappingCode
                                                }`}</p>
                                            </div>
                                        </GridChild>
                                    ) : (
                                        ''
                                    )}
                                </Grid>
                                <div>
                                    <Title className='text-capitalize padding-inline15'>
                                        {translate('guests')}
                                    </Title>
                                    <Grid
                                        style={{
                                            width: 'auto',
                                            padding: 20,
                                        }}
                                        columnSpacing={gridColumnsSpacing}
                                        rowSpacing={gridRowsSpacing}
                                    >
                                        {room.guests.map((guest, gueInd) => {
                                            return (
                                                <GridChild
                                                    key={guest.name + gueInd}
                                                    gridProps={avatarColumnGrid}
                                                >
                                                    <div
                                                        key={guest.name}
                                                        className='flex flex-align-center gap-10'
                                                    >
                                                        <BookingRoomAvatar
                                                            ageSegment={
                                                                guest.ageSegment
                                                            }
                                                        />
                                                        <div className='flex-column gap-5'>
                                                            <Title className='text-capitalize'>
                                                                {guest.name}
                                                            </Title>
                                                            <div className='flex gap-10 flex-align-center'>
                                                                <p>
                                                                    {guest.age}{' '}
                                                                    {translate(
                                                                        'years'
                                                                    )}
                                                                </p>
                                                                <Tag
                                                                    className='text-uppercase'
                                                                    text={translate(
                                                                        guest?.ageSegment?.toLowerCase()
                                                                    )}
                                                                    color={
                                                                        AGE_SEGMENT_COLOR[
                                                                            guest
                                                                                .ageSegment
                                                                        ]
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </GridChild>
                                            );
                                        })}
                                    </Grid>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Card>
        </section>
    );
};

export default HotelInfo;
